var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.3334 5.4 14.6 1.66666 10 1.66666C5.40002 1.66666 1.66669 5.4 1.66669 10C1.66669 14.0333 4.53335 17.3917 8.33335 18.1667V12.5H6.66669V10H8.33335V7.91666C8.33335 6.30833 9.64169 5 11.25 5H13.3334V7.5H11.6667C11.2084 7.5 10.8334 7.875 10.8334 8.33333V10H13.3334V12.5H10.8334V18.2917C15.0417 17.875 18.3334 14.325 18.3334 10Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7aca30716fcc41a2acb4202dbc345a31.svg";
export { ForwardRef as ReactComponent };